// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"d-","content":"d_","header":"ea","message":"eb","iframeWrapper":"ec"};